export default __webpack_public_path__ + "static/media/AktivGrotesk-XBold.6efa5773.ttf";